import React from "react";

import egypthotdeal from "../assets/images/egypthotdeal.webp";
import koreahotdeal from "../assets/images/koreahotdeal.webp";
import maldivesmobile from "../assets/images/maldivesmobile.webp";
import qatarmobile from "../assets/images/qatarmobile.webp";
import nepalmobile from "../assets/images/nepalmobile.webp";

const packages = [
  {
    image: koreahotdeal,
    location: "Korea",
    title: "Korea Cultural Escape",
    tag: "HOT DEAL",
    href:'/contact'
  },
  {
    image: qatarmobile,
    location: "Qatar",
    title: "Qatar Luxury Experience",
    tag: "HOT DEAL",
    href:'/contact'
  },
  {
    image: nepalmobile,
    location: "Nepal",
    title: "Nepal Himalayan Escape",
    tag: "HOT DEAL",
    href:'/contact'
  },
  {
    image: maldivesmobile,
    location: "Maldives",
    title: "Maldives Island Retreat",
    tag: "HOT DEAL",
    href:'/contact'
  },
  {
    image: egypthotdeal,
    location: "Egypt",
    title: "Egypt Ancient Wonders",
    tag: "HOT DEAL",
    href:'/contact'
  },
];

const HotDealsSection = () => {
  return (
    <section className="relative overflow-hidden bg-[#fff] px-5 py-16 sm:px-8 md:px-10 lg:px-12 xl:px-16 md:pb-16 md:pt-16">
      {/* Background Decoration */}
      <div className="pointer-events-none absolute -left-32 top-20 h-72 w-72 rounded-full bg-[#97BF49]/10 blur-3xl"></div>

      <div className="pointer-events-none absolute -right-32 bottom-10 h-80 w-80 rounded-full bg-[#019EE7]/10 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl">
        {/* Section Heading */}
        <div className="mx-auto mb-11 max-w-2xl md:text-center text-left">
          <span
            className=" inline-block text-[12px] sm:text-sm md:text-base font-bold tracking-[0.15em] md:tracking-[0.2em] text-[#007FC0]
            "
          >
            Exclusive Travel Deals
          </span>

          <h2 className="mt-3 text-left md:text-center m-0 text-[30px] sm:text-[38px] md:text-[58px] lg:text-[50px] font-semibold leading-[1.15] tracking-[-0.5px] md:tracking-[0.2px] text-[#12344A]">
            Hot Deals This Week
          </h2>

          <p className="md:text-center text-left mx-auto md:mt-4 mt-2 max-w-3xl text-[16px] font-medium leading-7 text-slate-500 sm:text-[18px] sm:leading-8 lg:text-[20px]">
            Catch the deal, catch the sky — explore handpicked journeys designed
            to make your next escape unforgettable.
          </p>
        </div>

        {/* Packages Grid */}
        <div className="grid grid-cols-1 gap-x-5 gap-y-10 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {packages.map((item, index) => (
            <div key={index} className="group relative">
              {/* Image Card */}
              <div className="relative h-[340px] overflow-hidden rounded-[22px] bg-[#dceaf0] shadow-[0_15px_40px_rgba(18,52,74,0.12)] transition-all duration-500 group-hover:-translate-y-1 group-hover:shadow-[0_22px_45px_rgba(18,52,74,0.18)] sm:h-[350px] lg:h-[355px]">
                {/* Image */}
                <img
                  src={item.image}
                  alt={item.title}
                  className="absolute h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />

                {/* Premium Image Overlay */}
                {/* <div className="absolute inset-0 bg-gradient-to-t from-[#12344A]/90 via-[#12344A]/20 to-transparent"></div> */}

                {/* Soft Color Overlay */}
                <div className="absolute inset-0 bg-[#12344A]/10 mix-blend-multiply"></div>

                {/* Deal Badge */}
                <div className="absolute left-4 top-4">
                  <span className="inline-flex items-center gap-1.5 rounded-full border border-white/20 bg-[#12344A]/70 px-3 py-1.5 text-[10px] font-bold tracking-[0.08em] text-white shadow-lg backdrop-blur-md">
                    <span className="h-1.5 w-1.5 rounded-full bg-[#97BF49]"></span>
                    {item.tag}
                  </span>
                </div>

                {/* Destination Heading */}
                {/* <div className="absolute bottom-[92px] left-5 right-5">
                  <p className="mb-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#97BF49]">
                    Destination
                  </p>

                  <h3 className="m-0 text-[26px] font-semibold leading-none tracking-[-0.4px] text-white">
                    {item.location}
                  </h3>
                </div> */}

                {/* Floating White Package Card */}
                <a href={item.href} className="absolute bottom-3 left-3 right-3 rounded-[17px] bg-white px-4 py-6 shadow-[0_-8px_25px_rgba(18,52,74,0.15)] transition-all duration-500 group-hover:-translate-y-1 sm:left-4 sm:right-4">
                  <div className="flex items-center justify-between gap-3">
                    <div className="min-w-0">
                      <p className="mb-1 text-[9px] font-semibold uppercase tracking-[0.15em] text-[#019EE7]">
                        Travel Package
                      </p>

                      <h3 className="m-0 line-clamp-1 text-[15px] font-bold leading-tight text-[#12344A]">
                        {item.title}
                      </h3>
                    </div>

                    {/* Arrow */}
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#97BF49] text-white transition-all duration-300 group-hover:translate-x-1 group-hover:bg-[#019EE7]">
                      <i className="las la-arrow-right text-[14px]"></i>
                    </span>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HotDealsSection;
